export const appConstants = {
  UPDATE_API_HOST: "UPDATE_API_HOST",
  MOVE_TO: "USER_MOVE_TO",
  SET_MENU: "USERS_SETMENU",
  SET_LANG: "USERS_SETLANG",
  SET_SETTINGS_TAB: "USERS_SET_SETTINGS_TAB",
};
